document.addEventListener("DOMContentLoaded", function() {
  const section = document.getElementById("video-section-1");
  const videos = section.querySelectorAll(".banner-video");
  const btn = section.querySelector(".video-toggle-btn");
  const poster = section.querySelector(".custom-poster");
  const iconPlay = btn.querySelector(".icon-play");
  const iconPause = btn.querySelector(".icon-pause");

  let isPlaying = false;

  // ▶️ Play / Pause button
  btn.addEventListener("click", () => {
    if (!isPlaying) {

      videos.forEach(video => {
        if (isElementVisible(video)) {
          video.muted = false;
          video.currentTime = 0;
          video.play().catch(err => console.log(err));
        }
      });

      if (poster) poster.style.opacity = "0";

      iconPlay.style.display = "none";
      iconPause.style.display = "block";
      isPlaying = true;

    } else {

      videos.forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      if (poster) poster.style.opacity = "1";

      iconPlay.style.display = "block";
      iconPause.style.display = "none";
      isPlaying = false;
    }
  });

  // 👀 Auto pause when section not visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {

      if (!entry.isIntersecting) {
        videos.forEach(video => {
          video.pause();
          video.currentTime = 0;
        });

        if (poster) poster.style.opacity = "1";

        iconPlay.style.display = "block";
        iconPause.style.display = "none";
        isPlaying = false;
      }

    });
  }, { threshold: 0.4 });

  observer.observe(section);

  // ✅ Helper: check visible video (mobile/desktop)
  function isElementVisible(el) {
    return window.getComputedStyle(el).display !== "none";
  }
});